export const SelectArrowIcon = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M8 14L3.66987 9.5L12.3301 9.5L8 14Z" fill="currentColor" />
            <path d="M8 3L12.3301 7.5L3.66987 7.5L8 3Z" fill="currentColor" />
        </svg>
    );
};
